import { useState, useEffect } from 'react'

export default function usePortalPosition(parentRef, options = {}) {
    const [position, setPosition] = useState({ top: 0, left: 0 })
    
    const {
        offsetTop = 5,
        offsetLeft = 0,
        placement = 'top',
        align = 'end',
        modalWidth = 250,
        modalHeight = 150
    } = options

    useEffect(() => {
        if (parentRef?.current) {
            const updatePosition = () => {
                const rect = parentRef.current.getBoundingClientRect()
                const viewportWidth = window.innerWidth
                const viewportHeight = window.innerHeight
                
                let top, left
                
                switch (placement) {
                    case 'bottom':
                        top = rect.bottom + offsetTop
                        break
                    case 'top':
                        top = rect.top - modalHeight - offsetTop
                        break
                    default:
                        top = rect.top - modalHeight - offsetTop
                }
                
                switch (align) {
                    case 'center':
                        left = rect.left + (rect.width / 2) - (modalWidth / 2)
                        break
                    case 'end':
                        left = rect.right - modalWidth + offsetLeft
                        break
                    case 'start':
                        left = rect.left + offsetLeft
                        break
                    default:
                        left = rect.right - modalWidth + offsetLeft
                }
                
                if (left < 10) {
                    left = 10
                } else if (left + modalWidth > viewportWidth - 10) {
                    left = viewportWidth - modalWidth - 10
                }
                
                if (top < 10) {
                    if (rect.bottom + modalHeight + offsetTop < viewportHeight - 10) {
                        top = rect.bottom + offsetTop
                    } else {
                        top = 10
                    }
                } else if (top + modalHeight > viewportHeight - 10) {
                    if (rect.top - modalHeight - offsetTop > 10) {
                        top = rect.top - modalHeight - offsetTop
                    } else {
                        top = viewportHeight - modalHeight - 10
                    }
                }
                
                setPosition({ top, left })
            }
            
            updatePosition()
            
            window.addEventListener('resize', updatePosition)
            window.addEventListener('scroll', updatePosition)
            
            return () => {
                window.removeEventListener('resize', updatePosition)
                window.removeEventListener('scroll', updatePosition)
            }
        }
    }, [parentRef, offsetTop, offsetLeft, placement, align, modalWidth, modalHeight])

    return position
} 